import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { McperApp } from './McperApp';

// Mock mode (`VITE_MOCK=true npm run dev`): the app runs against made-up data and no server, for looking at pages.
if (import.meta.env.VITE_MOCK === 'true') {
  const [{ http }, { installMock }] = await Promise.all([import('./api'), import('./mock')]);
  installMock(http);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <McperApp />
  </StrictMode>,
);
